/*
 *
 * SignUpPage actions
 *
 */

export const resetSubscriptionError = () => ({
  type: 'RESET_ERROR',
});

export const postSubscriptionSuccess = (payload) =>({
  type: 'PLAN_SUBSCRIPTION_SUCCESS',
  payload
});

export const postSubscriptionError = (payload) => ({
  type: 'PLAN_SUBSCRIPTION_ERROR',
  payload
});
export const niceChoiceRequest = (payload) => ({
  type: 'NICE_CHOICE_REQUEST',
  payload
})

export const togglePayinig = () =>({
  type: 'TOGGLE_PAYING',
})



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/actions.js